import { themeShadows } from "./themeColors";

export const components = {
  MuiTable: {
    styleOverrides: {
      root: { tableLayout: "fixed" }
    }
  },
  MuiTableCell: {
    defaultProps: {
      style: {
        fontFamily: "var(--font-family-sans)"
      }
    },
    styleOverrides: {
      head: {
        fontSize: "13px",
        padding: "12px 0px",
        fontWeight: 900,
        fontFamily: "var(--font-family-sans) !important"
      },
      root: {
        fontSize: "14px",
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        padding: "12px 8px 12px 0px",
        fontFamily: "var(--font-family-sans) !important",
        fontWeight: 400
      }
    }
  },
  MuiTypography: {
    defaultProps: {
      style: {
        fontFamily: "var(--font-family-sans)"
      }
    },
    styleOverrides: {
      root: {
        fontFamily: "var(--font-family-sans) !important"
      }
    }
  },
  MuiButton: {
    defaultProps: {
      style: {
        fontWeight: 800
      }
    },
    styleOverrides: {
      root: {
        fontFamily: "var(--font-family-sans)",
        fontSize: "14px",
        textTransform: "none",
        fontWeight: "800 !important",
        "&.MuiButtonBase-root": {
          fontWeight: "800 !important"
        },
        "&.css-1w1rijm-MuiButtonBase-root-MuiButton-root": {
          fontWeight: "800 !important"
        }
      },
      contained: { boxShadow: themeShadows[8] }
    }
  },
  MUIDataTableSelectCell: {
    styleOverrides: {
      root: { paddingLeft: 12 }
    }
  },
  MUIDataTableHeadCell: {
    styleOverrides: {
      root: {
        paddingLeft: 16,
        fontWeight: "900 !important",
        "& span": {
          fontWeight: "900 !important"
        },
        "& div": {
          fontWeight: "900 !important",
          boxSizing: "content-box"
        },
        "& p": {
          fontWeight: "900 !important"
        }
      },
      fixedHeader: {
        fontWeight: "700 !important",
        "& span": {
          fontWeight: "700 !important"
        },
        "& div": {
          fontWeight: "700 !important"
        }
      },
      toolButton: {
        fontWeight: "700 !important"
      }
    }
  },
  MUIDataTableBodyCell: {
    styleOverrides: {
      root: { paddingLeft: 8 }
    }
  },

  MuiCssBaseline: {
    styleOverrides: {
      "*:not(.material-icons):not(.MuiIcon-root)": {
        fontFamily: "var(--font-family-sans)"
      },
      html: {
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        height: "100%",
        width: "100%"
      },
      body: {
        height: "100%",
        fontFamily: "var(--font-family-sans)"
      },
      a: { textDecoration: "none", color: "inherit" },
      "#root": { height: "100%" },
      "#nprogress .bar": { zIndex: "2000 !important" }
    }
  },
  MuiFab: {
    styleOverrides: {
      root: { boxShadow: themeShadows[12] }
    }
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        "&:before": { display: "none" }
      }
    }
  },
  MuiIcon: {
    styleOverrides: {
      root: {
        fontFamily: "Material Icons !important"
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: { fontSize: "11px" }
    }
  },
  MuiMenuItem: {
    defaultProps: {
      style: {
        fontFamily: "var(--font-family-sans)"
      }
    },
    styleOverrides: {
      root: {
        fontSize: "0.875rem",
        fontFamily: "var(--font-family-sans) !important"
      }
    }
  },
  MuiExpansionPanel: {
    styleOverrides: {
      root: {
        "&:before": {
          display: "none"
        }
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "8px",
        boxShadow:
        "0px 3px 3px -2px rgb(0 0 0 / 6%), 0px 3px 4px 0px rgb(0 0 0 / 4%), 0px 1px 8px 0px rgb(0 0 0 / 4%) !important"
      }
    }
  }
};